var map = {
	"./MIPlogo-invert.svg": "./Scripts/styles/img/MIPlogo-invert.svg",
	"./bsg-logo.svg": "./Scripts/styles/img/bsg-logo.svg",
	"./by-cmg-02.svg": "./Scripts/styles/img/by-cmg-02.svg",
	"./by-cmg-white-02.svg": "./Scripts/styles/img/by-cmg-white-02.svg",
	"./check-mark-button.svg": "./Scripts/styles/img/check-mark-button.svg",
	"./envelope.svg": "./Scripts/styles/img/envelope.svg",
	"./equal-housing-lender.svg": "./Scripts/styles/img/equal-housing-lender.svg",
	"./fthb-guide.svg": "./Scripts/styles/img/fthb-guide.svg",
	"./grant-cert-circ.svg": "./Scripts/styles/img/grant-cert-circ.svg",
	"./lo-circ.svg": "./Scripts/styles/img/lo-circ.svg",
	"./mip-logo.svg": "./Scripts/styles/img/mip-logo.svg",
	"./phone.svg": "./Scripts/styles/img/phone.svg",
	"./preapproval-cert.svg": "./Scripts/styles/img/preapproval-cert.svg",
	"./preapproval-circ.svg": "./Scripts/styles/img/preapproval-circ.svg",
	"./qualify-circ.svg": "./Scripts/styles/img/qualify-circ.svg",
	"./success.svg": "./Scripts/styles/img/success.svg",
	"./successresult.svg": "./Scripts/styles/img/successresult.svg",
	"./web-bsfm.svg": "./Scripts/styles/img/web-bsfm.svg",
	"./web-cmg.svg": "./Scripts/styles/img/web-cmg.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./Scripts/styles/img sync \\.svg$";